const STORAGE_KEY = 'znqhb16_invite_flow';
const VERSION = 2;
const TTL = 60 * 60 * 1000;

function storage() {
    try {
        return window.sessionStorage;
    } catch (e) {
        return null;
    }
}

function read() {
    const store = storage();
    if (!store) return null;

    try {
        const value = JSON.parse(store.getItem(STORAGE_KEY));
        if (!value || value.version !== VERSION || !value.code || !value.flowId) return null;
        if (Date.now() - value.updatedAt > TTL) {
            store.removeItem(STORAGE_KEY);
            return null;
        }
        return value;
    } catch (e) {
        store.removeItem(STORAGE_KEY);
        return null;
    }
}

function write(flow) {
    const store = storage();
    if (!store) return flow;

    try {
        store.setItem(STORAGE_KEY, JSON.stringify(flow));
    } catch (e) {
        // sessionStorage may be unavailable in private browsing mode.
    }
    return flow;
}

function get() {
    const flow = read();
    return flow && flow.source === 'invite-code' ? flow : null;
}

function start(code) {
    const current = get();
    if (current && current.code === code) return current;

    return write({
        version: VERSION,
        flowId: Date.now().toString(36) + Math.random().toString(36).slice(2),
        source: 'invite-code',
        code,
        stage: 'login_pending',
        next: '',
        createdAt: Date.now(),
        updatedAt: Date.now(),
    });
}

function matches(flowId, code, stage, next) {
    const flow = get();
    if (!flow || flow.flowId !== flowId || flow.code !== code) return false;
    if (stage && flow.stage !== stage) return false;
    if (typeof next !== 'undefined' && flow.next !== next) return false;
    return true;
}

function setStage(flowId, stage, next = '') {
    const flow = get();
    if (!flow || flow.flowId !== flowId) return null;

    flow.stage = stage;
    flow.next = next;
    flow.updatedAt = Date.now();
    return write(flow);
}

function clear(flowId) {
    const store = storage();
    const flow = get();
    if (!store || !flow || (!flowId || flow.flowId === flowId)) {
        if (store) store.removeItem(STORAGE_KEY);
    }
}

function clearIfCode(code) {
    const flow = get();
    if (flow && flow.code === code) clear(flow.flowId);
}

function resetIfCodeMismatch(code) {
    const flow = get();
    if (flow && flow.code !== code) clear(flow.flowId);
}

export default {
    get,
    start,
    matches,
    setStage,
    clear,
    clearIfCode,
    resetIfCodeMismatch,
};
